import { useEffect, useState } from "react";
import ApiService from "../../core/service/ApiService";
import { t } from "i18next";
import { Select } from "antd";
import { useUser } from "../../core/context/UserContext";
import { matchesSearch } from "../../core/utils/text-search";

export default function UserSelectList({ showEntitlementConfirmUser = false, showSelf = false, includeDisabled = false, ...props }) {
    const [users, setUsers] = useState([]);
    const { firmSettings, user } = useUser()

    const getUsers = async () => {
        let _users = []
        if (showEntitlementConfirmUser) {
            const res2 = await ApiService.Entitlement.GetEntitlementConfirmUsers();
            if (res2.success) {
                _users = res2.data;
            }
        }

        const res = await ApiService.User.GetUserList({ Enable: null, Entitlement: true });
        if (res.success) {
            _users = res.data;
        }

        setUsers(_users)
    }

    useEffect(() => {
        getUsers()
    }, [])


    // Pasif kullanıcılar listeyi gereksiz kalabalıklaştırıyor; varsayılan olarak gizliyoruz.
    // Kayıtta zaten seçili olan pasif kullanıcı listede kalır, aksi halde mevcut atama
    // ekranda id olarak görünürdü. includeDisabled ile eski davranışa dönülebilir.
    const selectedValues = Array.isArray(props.value) ? props.value : (props.value != null ? [props.value] : []);
    const visibleUsers = includeDisabled
        ? users
        : users.filter(x => x.enabled !== false || selectedValues.includes(x.id));

    return (
        <Select
            style={{ width: 200 }}
            size={'small'}
            placeholder={t('Select User')}
            showSearch={true}
            filterOption={(input, option) => {
                return matchesSearch(option?.children?.toString(), input)
            }}
            {...props}
        >
            {
                visibleUsers.map(x => (
                    <Select.Option value={x.id} key={x.id}>
                        {x.enabled === false ? `${x.name} (${t('Passive')})` : x.name}
                    </Select.Option>
                ))
            }
        </Select>
    )
}